import React, { useEffect } from 'react';
import { Field, useFormState } from 'react-final-form';
import {
    validateEmailList,
    validateHost,
    validatePort,
    composeValidators,
    normalizePort, requiredIf
} from '../../../utils/form-validations';



const EverpriceDistribution = () => {

    const [formEnabled, setFormEnabled] = React.useState(false);

    const { values } = useFormState()

    const isFtpEnabled = (all) => !!all?.everprice_distribution?.ftp_enabled;


    useEffect(() => {
        if (values?.everprice_distribution?.ftp_enabled !== undefined) {
            setFormEnabled(!!values.everprice_distribution.ftp_enabled);
        }
    }, [values?.everprice_distribution?.ftp_enabled])

    return (
        <div >
            <h4 className="border-b-2 border-black">EVERPRICE® distribuzione</h4>
            <div className="grid grid-cols-3 gap-4">
                <div className="col-span-1">
                    <Field name="everprice_distribution.ftp_enabled" type={"checkbox"}
                    >
                        {({ input }) => (
                            <div>
                                <label>Ricevi file calcoli convenzione</label>
                                <div className="form-group">
                                    <label className="form-switch">
                                        <input
                                            type="checkbox"
                                            checked={input.checked}
                                            onChange={(e) => {
                                                input.onChange(e)
                                                setFormEnabled(e.target.checked)
                                            }}
                                        />
                                        <i className="form-icon" />
                                        Si/No
                                    </label>
                                </div>
                            </div>
                        )}
                    </Field>
                </div>
            </div>
            <div className="grid grid-cols-3 gap-4">
                <div className="col-span-1">
                    <Field
                        name="everprice_distribution.ftp_host"
                        validate={composeValidators(validateHost, requiredIf(isFtpEnabled))}
                        parse={(v) => (v || '').trim()}
                    >
                        {({ input, meta }) => (
                            <div className="form-group">
                                <label htmlFor="everprice_distribution.ftp_host">Host</label>
                                <input
                                    type="text"
                                    className={`form-input ${(meta.touched || meta.submitFailed) && meta.error ? 'is-error' : ''}`}
                                    disabled={!formEnabled}
                                    {...input}
                                />
                                {(meta.touched || meta.submitFailed) && meta.error && (
                                    <p className="form-input-hint text-error">{meta.error}</p>
                                )}
                            </div>
                        )}
                    </Field>
                </div>

                <div className="col-span-1">
                    <Field
                        name="everprice_distribution.ftp_port"
                        validate={composeValidators(validatePort)}
                        parse={normalizePort}
                    >
                        {({ input, meta }) => (
                            <div className="form-group">
                                <label htmlFor="everprice_distribution.ftp_port">Porta</label>
                                <input
                                    type="text"
                                    inputMode="numeric"
                                    pattern="[0-9]*"
                                    placeholder="22"
                                    className={`form-input ${meta.touched && meta.error ? 'is-error' : ''}`}
                                    disabled={!formEnabled}
                                    {...input}
                                />
                                {meta.touched && meta.error && (
                                    <p className="form-input-hint text-error">{meta.error}</p>
                                )}
                            </div>
                        )}
                    </Field>
                </div>

            </div>

            <div className="grid grid-cols-3 gap-4">
                <div className="col-span-1">
                    <Field name="everprice_distribution.ftp_username" type={"text"}
                    >
                        {props =>
                            <div className="form-group">
                                <label htmlFor="everprice_distribution.ftp_username">Username</label>
                                <input
                                    type="text"
                                    className="form-input"
                                    name={props.input.name}
                                    disabled={!formEnabled}
                                    value={props.input.value}
                                    onChange={props.input.onChange}
                                />
                            </div>
                        }
                    </Field>
                </div>

                <div className="col-span-1">
                    <Field name="everprice_distribution.ftp_password" type={"password"} placeholder="21"
                    >
                        {props =>
                            <div className="form-group">
                                <label htmlFor="everprice_distribution.ftp_password">Password</label>
                                <input
                                    type="password"
                                    className="form-input"
                                    disabled={!formEnabled}
                                    name={props.input.name}
                                    value={props.input.value}
                                    onChange={props.input.onChange}
                                />
                            </div>
                        }
                    </Field>
                </div>

            </div>


            <div className="grid grid-cols-3 gap-4">
                <div className="col-span-1">
                    <Field name="everprice_distribution.ftp_directory" type={"text"}
                    >
                        {props =>
                            <div className="form-group">
                                <label htmlFor="everprice_distribution.ftp_directory">Directory</label>
                                <input
                                    type="text"
                                    className="form-input"
                                    disabled={!formEnabled}
                                    name={props.input.name}
                                    value={props.input.value}
                                    onChange={props.input.onChange}
                                />
                            </div>
                        }
                    </Field>
                </div>

            </div>


            <div className="grid grid-cols-3 gap-4">
                <div className="col-span-3">
                    <Field name="everprice_distribution.ftp_email" validate={validateEmailList}>
                        {({ input, meta }) => (
                            <div className="form-group">
                                <label htmlFor="everprice_distribution.ftp_email">Email per notifica (suddividere con , )</label>
                                <textarea
                                    className={`form-input ${meta.touched && meta.error ? 'is-error' : ''}`}
                                    name={input.name}
                                    disabled={!formEnabled}
                                    value={input.value}
                                    onChange={input.onChange}
                                    onBlur={input.onBlur}
                                />
                                {meta.touched && meta.error && (
                                    <p className="form-input-hint text-error">{meta.error}</p>
                                )}
                            </div>
                        )}
                    </Field>
                </div>

            </div>
        </div>
    )
}

export default EverpriceDistribution